
    import './styles.scoped.css';
    export default {
  "content": "awsui_content_1wepg_1qvhh_145",
  "description": "awsui_description_1wepg_1qvhh_146",
  "label": "awsui_label_1wepg_1qvhh_147",
  "outline": "awsui_outline_1wepg_1qvhh_155",
  "show-outline": "awsui_show-outline_1wepg_1qvhh_158",
  "native-input": "awsui_native-input_1wepg_1qvhh_162",
  "wrapper": "awsui_wrapper_1wepg_1qvhh_166",
  "label-wrapper": "awsui_label-wrapper_1wepg_1qvhh_172",
  "empty-content": "awsui_empty-content_1wepg_1qvhh_183",
  "description-bottom-padding": "awsui_description-bottom-padding_1wepg_1qvhh_193",
  "label-disabled": "awsui_label-disabled_1wepg_1qvhh_201",
  "description-disabled": "awsui_description-disabled_1wepg_1qvhh_202",
  "control": "awsui_control_1wepg_1qvhh_206"
};
  